import restCrudActions from '../../../np-crud/store/restCrudActions'
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'error-logs',
    pluginName: 'ADMIN',
    entityName: 'ERROR_LOG',
    fetchSuccessMessage: '',
    loadSuccessMessage: ''
});

// Fetch ErrorLog action creators
export const fetchErrorLogInit = () => { return crudActions.fetchInit(); }
export const fetchErrorLogStart = () => { return crudActions.fetchStart(); }
export const fetchErrorLogSuccess = () => { return crudActions.fetchSuccess(); }
export const fetchErrorLogFail = () => { return crudActions.fetchFail(); }

export const fetchErrorLogCount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchErrorLogStart());
        try {
            let countRes = await rest.post("error-logs/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchErrorLogSuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(fetchErrorLogFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch error logs."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            dispatch(fetchErrorLogFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch error logs."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}

export const fetchErrorLog = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchErrorLogStart());
        try {
            let listRes = await rest.post("error-logs/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchErrorLogSuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(fetchErrorLogFail());
            return []

        } catch (error) {
            dispatch(fetchErrorLogFail());
            return []

        }
    }
}
